
import { Link } from 'react-router-dom';

export default function DifferentialsSection() {
  const differentials = [
    {
      icon: 'ri-lightbulb-line',
      title: 'Design Inteligente',
      description: 'Estética refinada e proporções equilibradas que valorizam cada ambiente com sofisticação e funcionalidade.'
    },
    {
      icon: 'ri-tools-line',
      title: 'Rigor Técnico',
      description: 'Precisão e responsabilidade profissional em cada cálculo, garantindo segurança e durabilidade.'
    },
    {
      icon: 'ri-time-line',
      title: 'Execução Eficiente',
      description: 'Planejamento detalhado que evita retrabalhos e atrasos, entregando resultados no prazo acordado.'
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Soluções Completas',
      description: 'Do projeto inicial à regularização e gestão, oferecemos um serviço integrado e completo.'
    }
  ];

  return (
    <section id="about" className="py-16 bg-[#F2F2F2]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-[#5C1A24] mb-4" style={{ fontFamily: '"Playfair Display", serif' }}>
            Na P&P, o luxo está na inteligência do projeto.
          </h2>
          <p className="text-lg text-[#3F3F3F] max-w-2xl mx-auto">
            Soluções sob medida para quem busca exclusividade.
          </p>
        </div>

        {/* Differentials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {differentials.map((item, index) => (
            <div 
              key={index}
              className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 group cursor-pointer"
            >
              <div className="w-12 h-12 bg-[#5C1A24] rounded-full flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                <i className={`${item.icon} text-white text-lg`}></i>
              </div>
              <h3 className="text-lg font-bold text-[#3F3F3F] mb-3">
                {item.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>

        {/* Subtitle */}
        <div className="text-center mt-12">
          <p className="text-base text-[#3F3F3F] max-w-3xl mx-auto font-medium">
            Nosso time é movido por um único objetivo: entregar resultados de excelência para clientes que valorizam a sofisticação com fundamento técnico.
          </p>
        </div>
      </div>
    </section>
  );
}